"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SplitButton = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _dropdownMenu = require("@cld/dropdown-menu");
var _icon = require("@cld/icon");
var _Button = require("./Button");
var _ButtonGroup = require("./ButtonGroup");
var _SplitButton = require("./SplitButton.styled");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SplitButton = ({
  children,
  overlay,
  variant = 'primary',
  onClick,
  ...buttonProps
}) => {
  const [isMenuOpen, setIsMenuOpen] = (0, _react.useState)(false);
  const handleMenuOpen = newMenuState => {
    setIsMenuOpen(newMenuState);
  };
  return /*#__PURE__*/_react.default.createElement(_ButtonGroup.ButtonGroup, {
    variant: variant
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, _extends({
    onClick: onClick,
    variant: variant
  }, buttonProps), children), /*#__PURE__*/_react.default.createElement(_dropdownMenu.DropdownMenu, {
    placement: "bottomRight",
    items: overlay,
    afterVisibleChange: handleMenuOpen
  }, /*#__PURE__*/_react.default.createElement(_SplitButton.SecondButton, _extends({
    variant: variant,
    isMenuOpen: isMenuOpen
  }, buttonProps), /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "keyboardArrowDown"
  }))));
};
exports.SplitButton = SplitButton;
SplitButton.propTypes = {
  ..._Button.Button.propTypes,
  variant: _propTypes.default.oneOf(['primary', 'secondary']).isRequired,
  overlay: _propTypes.default.node.isRequired,
  onClick: _propTypes.default.func
};
//# sourceMappingURL=SplitButton.js.map